







































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
 
import DefaultTransferOrder from "./default.vue";
import BillofLading from './billoflading.vue';
import EditTransFerreception from './edit-transferreception.vue';
import LabelInfo from './label.vue';

class PageBHUserRequest extends PageRequest {
  Keyword: string;
   
  stime: Date;
  etime: Date;
  dispatchcarstatus:number;//派车状态
  declarestatus:number; //转移状态
  signstatus:number; //签收状态
}

 @Component({
        components:{
         //   CreateTransferOrder,EditTransferOrder
         EditTransFerreception
         ,DefaultTransferOrder
         ,BillofLading
         ,LabelInfo
            }
    })
export default class TransferOrder extends AbpBase {
  edit() {
    this.editModalShow = true;
  }
  //filters
  pagerequest: PageBHUserRequest = new PageBHUserRequest();
   
defaultshow(){
  this.defaultModalShow=true;
}
 
  billModalShow: boolean = false;
  editModalShow: boolean = false;
  defaultModalShow: boolean = false;
  labelModalShow: boolean = false;
  get list() {
                   
    return this.$store.state.transferorder.list;
  }
  get loading() {
    return this.$store.state.transferorder.loading;
  }
  billShow() {
    this.billModalShow = true;
  }
  labelShow(){
    this.labelModalShow = true;
  }

  pageChange(page: number) {
    this.$store.commit("transferorder/setCurrentPage_S", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("transferorder/setPageSize_S", pagesize);
    this.getpage();
  }
 
  async getpage() {
     if(this.pagerequest.signstatus==undefined){
      this.pagerequest.signstatus=-1;
     }
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    //filters

    

    await this.$store.dispatch({
      type: "transferorder/getAll",
      data: this.pagerequest,
    });
  }
     
  get pageSize() {
    return this.$store.state.transferorder.pageSize_S;
  }
  get totalCount() {
    return this.$store.state.transferorder.totalCount;
  }
  get currentPage() {
    return this.$store.state.transferorder.currentPage_S;
  }
   
 
  columns = [
     {
      
      title: this.L("编号"),
      key: "ordernumber",
      width: 180,
      render: (h, params) => {
    return h("div", {
        style: {
            color:'#2d8cf0'
        },
         on: {
                click: () => {
                
                  this.$store.commit("transferorder/edit", params.row);
                  this.defaultshow();
                },
              },
        },
        params.row.ordernumber
    )
    }},
    	
     {
      
      title: this.L("产废单位"),
      key: "nameen",
      render: (h: any, params: any) => {
      var txt=params.row.productionWaste.corporatename;
        return h("span", txt);
      },
    },
      {
      
      title: this.L("运输单位"),
      key: "nameen",
      render: (h: any, params: any) => {
         var txt="";
         if(params.row.transPorted!=null){
            txt=params.row.transPorted.corporatename;
         }
        
        return h("span", txt);
      },
    },
    {
      
      title: this.L("区域"),
      key: "nameen",
       width: 110,
      render: (h: any, params: any) => {
        //"county": "江阴市",
        //            "village": "江阴高新技术产业开发区"
      var county=params.row.productionWaste.county;
      var village=params.row.productionWaste.village;
      var txt=county+"-"+village;
        return h("span", txt);
      },
    },
     {
      
      title: this.L("危废物"),
      key: "hazardouswaste",
      width: 180,
    },
      {
      
      title: this.L("转移重量(kg)"),
      key: "weight",
      width: 110,
    },
    {
      
      title: this.L("数量"),
      key: "quantity",
      width: 70,
    },
    
     {
      title: this.L("签收时间"),
      width: 90,
      render: (h: any, params: any) => {
        var time="";
        if(params.row.signeetime!=null){
            time=new Date(params.row.signeetime).toLocaleDateString();
        }
        return h("span", time);
      },
    },
 
    {
    
      title: this.L("签收状态"),
       width: 90,
      render: (h: any, params: any) => {
        var txt=this. getsignstatustxt(params.row.signstatus);
         return h("span", txt);
      },
    },
    
     
     
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 200,
      render: (h: any, params: any) => {
      var btnlist=[];
      /*[
           h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                
                  this.$store.commit("transferorder/edit", params.row);
                  this.defaultshow();
                },
              },
            },
            this.L("详细")
          )

      ];*/
        if(params.row.declarestatus==1&&params.row.dispatchcarstatus==1&&params.row.signstatus==0){
         btnlist.push(   h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                 this.$store.commit("transferorder/edit", params.row);
                 this.edit();
                    
                },
              },
            },
            this.L("签收")
          ))}
          btnlist.push(
            h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                
                  this.$store.commit("transferorder/edit", params.row);
                  this.billShow();
                },
              },
            },
            this.L("联单")
          )

          )

          btnlist.push(
            h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                
                  this.$store.commit("transferorder/edit", params.row);
                  this.labelShow();
                },
              },
            },
            this.L("标签")
          )

          )

          btnlist.push( h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("UpdateDataOptConfirm"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                       type: "transferorder/updatedeclarestatus",
                        data: {id:params.row.id,status:2},
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("作废")
          ))
    

        return h("div", btnlist
       );
      },
    },
  ];
  async created() {
    this.pagerequest.declarestatus=1;
    this.pagerequest.dispatchcarstatus=1;
    this.getpage();
    this.getEnterpriseInformationAll();
    this.getNowUser()
  }
    //产废企业信息
    async  getEnterpriseInformationAll() {
     await this.$store.dispatch({
      type: "transferorder/getEnterpriseInformationAll",
      data: {corporatetype:0},
    });
  }
   //获取当前登录信息
    async  getNowUser() {
      var uid=abp.session.userId;
     
    
     await this.$store.dispatch({
      type: "transferorder/getNowUser",
      data: {id: uid}
    });
  }
  
   

  getsignstatustxt(id){
            var txt="";
               var list =this.$store.state.transferorder.signstatus;
             list.forEach(item=>{
                   if(id==item.id){
                    txt=item.name;
                    return txt;
                   }
             })
             return txt;
   }

   
    
 

 //导出
   async  exportExcel() {
   
     this.pagerequest.maxResultCount = 999999999;
     this.pagerequest.skipCount =0;
     let lt= await this.$store.dispatch({
      type: "transferorder/getAllexportExcel",
      data: this.pagerequest,
    });
 
      if(lt!=null){       
       
            
            
			   	require.ensure( [], () => {
					const { export_json_to_excel } = require('@/lib/excel/export2Excel.js');
          
					// 这里深拷贝，修改值时不会影响到原对象
				
					lt.map((item) => { // 这里修改要下载的字段内容
					  item.status == false ? item.status = '否' : item.status == true ?  item.status ='是' : item.status ='否'
         
          
					  return item;
					});
    
					const filterVal = ['id', 'nameen','namecn','status' ];// 取出要下载的表头字段
					const tHeader = ['ID','废物类别','废物类别名称','是否启用'];// 把表头字段定义成想要的中文或英文
					const data = this.formatJson(filterVal, lt);
					  export_json_to_excel(tHeader, data, '废物类别');// 定义excel下载成功的表名
					});			
								
             }

        }

			formatJson(filterVal, jsonData) {
			     return jsonData.map(v => filterVal.map(j => v[j]))
			}

			
}
